// ---BT-107433_SrikanthRao_9-10-2023_Calculator || Functional Implementation
export const _calcFairValue = (indexprice, interestprice, dividend, contractdays) => {
    let FairValue;
    try {
        let dblExpo = Math.pow(2.71, ((interestprice / 100) * (contractdays / 365)));
        FairValue = (((indexprice * dblExpo) - dividend)).toFixed(4);
        // FairValue = formatNumber(parseFloat(FairValue), 4);
    } catch (error) {
        FairValue = '';
        // console.log('CalculatorsFairvaluePage', error);
    }
    return FairValue;

};
export const _validateOptionValues = (obj, DaysDiff) => {


    let objValidateWarnings = {
        contract: false,
        spotPrice: false,
        interestRate: false,
        dividend: false,
        calculate: false,
    };

    try {

        // let DaysUntilExpiration = parseFloat(_dateDiffernece(obj.expiryOrContractDays));
        //let DaysUntilExpiration = obj?.expiryOrContractDays?.nDayDiff; 
        let DaysUntilExpiration = DaysDiff;//ManasaB : 26-03-2024 : Changed after discussion with Srikanth for contract validation
        if (DaysUntilExpiration === undefined || DaysUntilExpiration == null || DaysUntilExpiration <= 0) {
            objValidateWarnings.contract = true;
        };

        if (DaysUntilExpiration > 1800) {
            objValidateWarnings.contract = true;

        };



        if (obj.spotPrice <= 0 || obj.spotPrice > 99999.9999) {
            objValidateWarnings.spotPrice = true;

        }

        if (isNaN(obj.interestRate)) {
            objValidateWarnings.interestRate = true;


        }

        if (obj.interestRate < 0.01 || obj.interestRate > 99.99) { //BT-107433 Calculator - ManasaB : 22-03-2024 : SAT 2 Issues :Changed as per BA comments
            objValidateWarnings.interestRate = true;

        }


        if (obj.dividend < 0 || obj.dividend > 99.99 || obj.dividend.length === 0) { //BT-107433 Calculator - ManasaB : 22-03-2024 : SAT 2 Issues :Changed as per BA comments
            objValidateWarnings.dividend = true;

        }

        if (isNaN(obj.dividend)) {
            objValidateWarnings.dividend = true;

        }
        // ---for future use-----

        // if (originalList.length > 0) {
        //     let expirypresent = false;
        //     for (let counter = 0; counter < originalList.length; counter++) {
        //         let covertedDate = originalList[counter].Date.substr(0, 2) + ' ' + originalList[counter].Date.substr(2, 3) + ' ' + "'" + originalList[counter].Date.substr(-2);
        //         if (covertedDate == expiryDate) {
        //             expirypresent = true;
        //         }
        //     }

        //     if (!expirypresent) {
        //         // showAlert('Enter Proper Expiry in Contract Days');
        //         return false;
        //     }
        // }



        return objValidateWarnings;

    } catch (error) {
        console.log("error", error);

    }

};